import { IColumn, Stack, Text, TooltipHost } from '@fluentui/react';
import { NotificationCycleRowItem } from '.';
import { NotificationCycleModalView } from '../view';

export type ColumnStylesProps = {
  onRenderColumnStack: string;
};
const dayKeys = [
  'isSentMonday',
  'isSentTuesday',
  'isSentWednesday',
  'isSentThursday',
  'isSentFriday',
  'isSentSaturday',
  'isSentSunday',
] as const;

const dayLabels: Record<(typeof dayKeys)[number], string> = {
  isSentMonday: 'Monday',
  isSentTuesday: 'Tuesday',
  isSentWednesday: 'Wednesday',
  isSentThursday: 'Thursday',
  isSentFriday: 'Friday',
  isSentSaturday: 'Saturday',
  isSentSunday: 'Sunday',
};

export const onRenderItems = (styles: ColumnStylesProps) => {
  const renderItemColumn = (
    item: NotificationCycleRowItem | undefined,
    _index: number | undefined,
    column: IColumn | undefined
  ) => {
    if (item) {
      const fieldContent = item[
        column?.fieldName as keyof NotificationCycleRowItem
      ] as string;
      switch (column?.key) {
        case 'notifyType':
          return (
            <TooltipHost content={item.notifyType?.hint ?? undefined}>
              <Stack
                horizontal
                verticalAlign="center"
                tokens={{ childrenGap: 3 }}
              >
                {item.notifyType?.description}
              </Stack>
            </TooltipHost>
          );
        case 'timeZone':
          return (
            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 3 }}
            >
              {item.timeZone?.standardTimeZoneCode}
            </Stack>
          );
        case 'sentOnDays':
          const selectedDays = dayKeys
            .filter((key) => item[key])
            .map((key) => dayLabels[key])
            .join(', ');

          return <Text>{selectedDays}</Text>;

        case 'action':
          return (
            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 3 }}
            >
              <NotificationCycleModalView notificationCycle={item} />
            </Stack>
          );

        default:
          return (
            <Stack
              verticalAlign="center"
              className={styles.onRenderColumnStack}
            >
              <Text>{fieldContent}</Text>
            </Stack>
          );
      }
    }
  };
  return renderItemColumn;
};
